import { useQuery } from "@msuite/ui/query";
import { responseHandler } from "@msuite/ui/utils";
import { guardArray } from "@msuite/utils/array";
import { client } from "@/hono";
import { useCitadel } from "@/hooks/use-citadel";

/**
 * The days in a window on which a crew stands short, keyed by crew definition.
 *
 * The server answers dates and crew ids only — never who is absent — so this carries no personal
 * data and needs no narrowing of its own.
 */
export function useCrewDefinitionAbsenceDays(startDate: string, endDate: string) {
	/** Hooks */
	const { citadel } = useCitadel();

	/** Computed */
	const canRead = citadel ? citadel.can("read", "Plan") : true;

	/** Query */
	const query = useQuery({
		queryKey: ["crew-definitions", "absence-days", startDate, endDate],
		queryFn: async () => {
			const response = await client.crew_definitions["absence-days"].$get({
				query: { startDate, endDate },
			});
			const data = await responseHandler(response);
			return data.absenceDays;
		},
		enabled: canRead,
	});

	/** Return */
	return { ...query, absenceDays: guardArray(query.data) };
}
